module.exports = __webpack_public_path__ + "static/about-622e721a493bd2864042d6818eeefbf2.png";